<div class="container">
    <div class="cases-panel">
        <div class="title-row" *ngrxLet="unsubmittedDatasets$ as datasets">
            <h3>
                Unsubmitted datasets
                <button
                    *ngIf="datasets && datasets.length === 0"
                    class="wiki-btn"
                    (click)="goToWiki()"
                >
                    ?
                </button>
            </h3>
            <cds-button size="sm" (click)="newDatasetClicked()" class="icon-button upload">
                <cds-icon shape="plus"></cds-icon>
                Dataset
            </cds-button>
        </div>
        <ng-container *ngrxLet="unsubmittedDatasets$ as datasets">
            <ng-container *ngIf="datasets && datasets.length > 0">
                <div class="flex-column cases-content scroll">
                    <ng-container *ngFor="let dataset of datasets">
                        <div class="row case-browser-grid">
                            <div class="col-1">
                                <button
                                    [title]="dataset.name"
                                    (click)="goToUnsubmittedDataset(dataset)"
                                    class="icon-button file-button"
                                    [attr.aria-label]="'Open dataset ' + dataset.name"
                                >
                                    <cds-icon
                                        shape="file"
                                        [solid]="true"
                                        status="neutral"
                                    ></cds-icon>
                                    {{ dataset.name }}
                                </button>
                            </div>
                            <div class="col-2">{{ dataset.size | fileSize }}</div>
                            <div class="col-3">
                                {{ dataset.date ? (dataset.date | date : 'dd.MM.yyyy') : '' }}
                            </div>
                            <div class="col-4">
                                <button
                                    (click)="deleteFile(dataset)"
                                    class="icon-button"
                                    [attr.aria-label]="'Delete dataset ' + dataset.name"
                                >
                                    <cds-icon shape="trash"></cds-icon>
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
    </div>
    <div class="cases-panel">
        <div class="title-row">
            <h3>My datasets</h3>
            <cds-button
                size="sm"
                (click)="createFolder(null)"
                class="icon-button upload"
                [attr.aria-label]="'Create new folder on root level'"
            >
                <cds-icon shape="plus"></cds-icon>
                Folder
            </cds-button>
        </div>
        <div class="flex-column cases-content scroll">
            <div
                cdkDropList
                [id]="rootDropTargetId"
                [cdkDropListConnectedTo]="dropTargetIds"
                [cdkDropListSortingDisabled]="true"
                (cdkDropListDropped)="onDropNodeToRoot($event)"
            >
                <cdk-tree
                    [dataSource]="dataSource$"
                    [treeControl]="treeControl"
                    [trackBy]="trackByFn"
                >
                    <!-- leaf node template -->
                    <ng-container *ngrxLet="currentCaseId$ as currentCaseId">
                        <cdk-nested-tree-node *cdkTreeNodeDef="let node">
                            <div class="row case-browser-grid">
                                <div
                                    class="col-1"
                                    cdkDrag
                                    [cdkDragDisabled]="!node.is_ready"
                                    [cdkDragPreviewContainer]="'parent'"
                                    [cdkDragData]="node"
                                    (cdkDragStarted)="onDragStart($event)"
                                    [cdkTreeNodePadding]="node.nestingLevel"
                                    cdkTreeNodePaddingIndent="1.3rem"
                                >
                                    <button
                                        [title]="
                                            node.is_ready
                                                ? node.name
                                                : 'Data conversion in progress'
                                        "
                                        (click)="setCase(node)"
                                        [disabled]="!node.is_ready"
                                        class="icon-button file-button"
                                        [class.highlight]="node.id == currentCaseId"
                                        [attr.aria-label]="'Open dataset ' + node.name"
                                    >
                                        <cds-icon
                                            [shape]="getNodeIconShape(node)"
                                            [solid]="true"
                                            status="neutral"
                                        ></cds-icon>
                                        {{ node.name }}
                                    </button>
                                </div>
                                <div class="col-2">{{ node.size | fileSize }}</div>
                                <div class="col-3">
                                    {{ node.date ? (node.date | date : 'dd.MM.yyyy') : '' }}
                                </div>
                                <div class="col-4">
                                    <button
                                        (click)="deleteFile(node)"
                                        class="icon-button"
                                        [attr.aria-label]="'Delete dataset ' + node.name"
                                    >
                                        <cds-icon shape="trash"></cds-icon>
                                    </button>
                                </div>
                            </div>
                        </cdk-nested-tree-node>
                    </ng-container>

                    <!-- non-leaf node template -->
                    <cdk-nested-tree-node *cdkTreeNodeDef="let node; when: isFolder">
                        <div
                            cdkDropList
                            [id]="'drop-list-folder-id-' + node.id"
                            [cdkDropListData]="node"
                            [cdkDropListConnectedTo]="dropTargetIds"
                            [cdkDropListSortingDisabled]="true"
                            (cdkDropListDropped)="onDropNode($event)"
                            (cdkDropListEntered)="onDropListEntered($event)"
                            (cdkDropListExited)="onDropListEntered(null)"
                        >
                            <div class="case-browser-grid row">
                                <div
                                    class="col-1"
                                    cdkDrag
                                    [cdkDragPreviewContainer]="'parent'"
                                    [cdkDragData]="node"
                                    (cdkDragStarted)="onDragStart($event)"
                                    [cdkTreeNodePadding]="node.nestingLevel"
                                    cdkTreeNodePaddingIndent="1.3rem"
                                >
                                    <ng-container
                                        *ngIf="
                                            (node.children?.length ?? 0) > 0;
                                            else childlessFolder
                                        "
                                    >
                                        <button
                                            cdkTreeNodeToggle
                                            class="icon-button"
                                            [attr.aria-label]="'Toggle ' + node.name"
                                        >
                                            <cds-icon
                                                shape="angle"
                                                [direction]="
                                                    treeControl.isExpanded(node) ? 'down' : 'right'
                                                "
                                                class="toggle-icon"
                                            ></cds-icon>
                                            <cds-icon
                                                shape="folder"
                                                [solid]="true"
                                                status="info"
                                            ></cds-icon>
                                            {{ node.name }}
                                        </button>
                                    </ng-container>

                                    <ng-template #childlessFolder>
                                        <div class="childless-folder">
                                            <cds-icon
                                                shape="folder"
                                                [solid]="true"
                                                status="info"
                                            ></cds-icon>
                                            {{ node.name }}
                                        </div>
                                    </ng-template>
                                </div>
                                <div class="col-4">
                                    <button
                                        (click)="createFolder(node)"
                                        class="icon-button"
                                        [attr.aria-label]="'Create new folder in ' + node.name"
                                    >
                                        <cds-icon shape="plus"></cds-icon>
                                    </button>
                                    <button
                                        (click)="deleteFolder(node)"
                                        class="icon-button"
                                        [attr.aria-label]="'Delete folder ' + node.name"
                                    >
                                        <cds-icon shape="trash"></cds-icon>
                                    </button>
                                </div>
                            </div>
                            <div [class.children-invisible]="!treeControl.isExpanded(node)">
                                <ng-container cdkTreeNodeOutlet></ng-container>
                            </div>
                        </div>
                    </cdk-nested-tree-node>
                </cdk-tree>
            </div>
        </div>
    </div>
</div>
